module.exports = __webpack_public_path__ + "5f453f4bbfc61848a486aeaf4c18e9cc.png";


//////////////////
// WEBPACK FOOTER
// ./assets/images/patches/head/zombie-bolts.png
// module id = 2351
// module chunks = 0